import {Link} from 'react-router-dom'
import {AlertCircle} from 'lucide-react'
import {routes} from '@/lib/routes'
import {useI18n} from '@/i18n'
import type {ErrorLogRef} from '@/types/common'

interface ErrorLogLinkProps {
    errorLogRef: ErrorLogRef | null
    sourceType?: string
    sourceId?: string
}

export function ErrorLogLink({errorLogRef, sourceType, sourceId}: ErrorLogLinkProps) {
    const i18n = useI18n()

    if (!errorLogRef) return null

    /* eslint-disable i18next/no-literal-string -- testid construction, not user-facing text */
    const testId = sourceType && sourceId
        ? `failure-link-${sourceType}-${sourceId}`
        : 'failure-link'
    /* eslint-enable i18next/no-literal-string */

    return (
        <Link
            to={routes.admin.errorLogs.detail(errorLogRef.errorLogId)}
            onClick={(e) => e.stopPropagation()}
            title={i18n.common.viewFailureDetails as string}
            data-testid={testId}
        >
            <AlertCircle className="h-4 w-4 text-destructive hover:text-destructive/80"/>
        </Link>
    )
}
